export default (value = '') => {
    return value ? value.replace(/<a (.+)>(.*)(http(s?):\/\/.*\.(jpg|png))(.*)<\/a>/gim, '<a $1><img src="$3" alt="" class="d-block my-2"/></a>') : ''
}